import API from '@/services/api'

const state = {
  userAlerts: [],
  unreadCount: 0,
  loading: false,
}

const mutations = {
  SET_USER_ALERTS(state, alerts) {
    state.userAlerts = alerts
    state.unreadCount = alerts.filter(a => !a.viewed).length
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
}

const actions = {
  async fetchUserAlerts({ commit }) {
    commit('SET_LOADING', true)
    try {
      const alerts = await API.getUserAlerts()
      commit('SET_USER_ALERTS', alerts)
    } catch (error) {
      console.error('Error fetching user alerts:', error)
    } finally {
      commit('SET_LOADING', false)
    }
  },
}

const getters = {
  pendingAlertsCount: state =>
    state.userAlerts.filter(a => a.status === 'pending').length,
  approvalAlertsCount: state =>
    state.userAlerts.filter(a => a.status === 'pending_approval').length,
  totalAlertsCount: (state, getters) =>
    getters.pendingAlertsCount + getters.approvalAlertsCount,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
